import { EventPeriod } from '@/constants';
import { createSimpleDictionary } from '@/stores/utils/createSimpleDictionary';
import { IEventPeriodDictionaryItem } from '@/types';

export const eventPeriodDictionary = createSimpleDictionary<IEventPeriodDictionaryItem>(
    [
        { id: EventPeriod.FullTime, name: 'dictionaries.eventPeriod.periodFT', code: 'dictionaries.eventPeriod.periodFTShort' },
        { id: EventPeriod.FirstHalf, name: 'dictionaries.eventPeriod.period1H', code: 'dictionaries.eventPeriod.period1HShort' },
    ],
    ['name', 'code']
);
